import React, { useContext, useEffect } from 'react';
import { Box, Text, Heading, Icon, IconSize } from '@bechtel/gds';
import { get, map } from 'lodash';
import { Trans } from '@lingui/macro';
import { useNavigate } from 'react-router-dom';
import { CacheKeys, ErrorRetry } from '@bechtel/client-common';
import { ListContainerStyled, ListSelectionStyled, RodRoomContainerStyled, RodRoomLogoStyled } from './styled';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { ReactComponent as ArcStrykerBlueLogo } from '@bechtel/client-assets/dist/images/arc-stryker-blue-logo.svg';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { ReactComponent as ArcStrykerBlueLabel } from '@bechtel/client-assets/dist/images/arc-stryker-blue-label.svg';
import { useRodRoomListQuery } from '@bechtel/client-weld-common';
import { RodRoomDataContext } from '~/utilities/context';

export const RodRoomList = () => {
  const navigate = useNavigate();
  const { selectedRodRoom, setSelectedRodRoom } = useContext(RodRoomDataContext);

  const { loading, error, data, refetch } = useRodRoomListQuery(true);

  useEffect(() => {
    if (!selectedRodRoom) return;
    navigate('/rod-room/requests');
  }, [navigate, selectedRodRoom]);

  const rodRoomList = get(data, 'rodRooms', []);

  return (
    <RodRoomContainerStyled data-testid="rod-room-layout-container">
      <Box data-testid="rod-room-container" flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }}>
        <Box
          mb={{ sm: '450' }}
          data-testid="logo-container"
          flexDirection={{ sm: 'column' }}
          alignItems={{ sm: 'center' }}
        >
          <Box mb={{ sm: '450' }}>
            <ArcStrykerBlueLogo />
          </Box>
          <ArcStrykerBlueLabel />
        </Box>
        <RodRoomLogoStyled data-testid="rod-room-logo">
          <Box mx={{ sm: '600' }} my={{ sm: '400' }}>
            <Icon icon="chimney" size={IconSize.MEDIUM} fillColor="white" data-testid="rod-room-icon" />
            <Box pl={{ sm: '400' }}>
              <Text size="400" color="white" family="graphik" data-testid="rod-room-label">
                <Trans>Rod Room</Trans>
              </Text>
            </Box>
          </Box>
        </RodRoomLogoStyled>
        <ListContainerStyled data-testid="rod-room-list-container">
          {!error && !loading && (
            <>
              <Box mx={{ sm: '500' }} my={{ sm: '550' }}>
                <Heading size={'600'} weight={'600'} family="graphik">
                  <Trans>Which Rod Room are you logged in today?</Trans>
                </Heading>
              </Box>
              <Box flexDirection={{ sm: 'column' }} css={{ overflowY: 'auto' }} data-testid="rod-room-lists">
                {map(rodRoomList, (rodRoom) => {
                  return (
                    <ListSelectionStyled
                      key={rodRoom.id}
                      onClick={() => {
                        setSelectedRodRoom(rodRoom);
                        window.sessionStorage.setItem(CacheKeys.SelectedRodRoom, JSON.stringify(rodRoom));
                      }}
                      data-testid="rod-room-list"
                    >
                      <Box data-testid="rod-room-list-name" flexDirection={{ sm: 'column' }}>
                        <Box mb={{ sm: '100' }}>
                          <Text size="400" weight="600">
                            {rodRoom?.name}
                          </Text>
                        </Box>
                        <Text size="300" color="grey.600">
                          {rodRoom?.locationDescription}
                        </Text>
                      </Box>
                      <Icon icon="chevron-right" fillColor="blue.800" size={IconSize.MEDIUM}></Icon>
                    </ListSelectionStyled>
                  );
                })}
              </Box>
            </>
          )}
          {!loading && error && (
            <Box data-testid="rod-room-list-error">
              <ErrorRetry refetch={refetch}>
                <Trans>There was a problem loading Rod Room List. Please click the button below to try again.</Trans>
              </ErrorRetry>
            </Box>
          )}
        </ListContainerStyled>
      </Box>
    </RodRoomContainerStyled>
  );
};
